import type { TFunction } from 'i18next'
import { setPintxoConfig } from '@/tools/ui'

export const setConfig = (t: TFunction) => {
  setPintxoConfig({
    accessibility: {
      tags: {
        close: 'common.close',
        collapse: 'common.collapse',
        expand: 'common.expand',
        next: 'common.next',
        previous: 'common.previous',
        slides: 'slides.plural',
      },
      functions: {
        getDotReference: (index: number) => () => t('slides.slide', { slideIndex: index + 1 }),
        getSlideOfTotal: (index: number, total: number) => () =>
          t('slides.current_slide_of_slides_count', {
            currentSlide: index + 1,
            slideCount: total,
          }),
      },
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    translator: (key: string, ...args: any[]) => String(t(key, ...(args as [any]))),
  })
}
